import React, { FC } from "react";
import { Button, Flex } from "@chakra-ui/react";

type TabsBarProps = {
  activeTab: "unsorted" | "assigned";
  tabCounts: { unsorted: number; assigned: number };
  onChange: (tab: "unsorted" | "assigned") => void;
};

export const TabsBar: FC<TabsBarProps> = ({ activeTab, tabCounts, onChange }) => {
  return (
    <Flex w="100%" justifyContent="space-between" alignItems="center">
      <Flex border="1px solid #E5E7EB" borderRadius="10px" p="6px" gap="8px" bg="#F8FAFC" w="100%">
        {[
          { id: "unsorted" as const, label: "Неотсортированные" },
          { id: "assigned" as const, label: "Назначенные" },
        ].map((tab) => (
          <Button
            key={tab.id}
            onClick={() => onChange(tab.id)}
            bg={activeTab === tab.id ? "#3B82F6" : "transparent"}
            color={activeTab === tab.id ? "white" : "#5C657E"}
            _hover={{ bg: activeTab === tab.id ? "#3B82F6" : "#EEF2F7" }}
            borderRadius="8px"
            px="16px"
            py="8px"
            w="50%"
          >
            {tab.label} ({tab.id === "unsorted" ? tabCounts.unsorted : tabCounts.assigned})
          </Button>
        ))}
      </Flex>
    </Flex>
  );
};
